import type { inferRouterOutputs } from '@trpc/server';
import type { AppRouter } from '@/types/appRouter';

type ReadinessSummaryResult = inferRouterOutputs<AppRouter>['strategyReadiness']['getReadinessSummaryBatch'];
type FetchReadinessBatch = (input: { strategyIds: number[] }) => Promise<ReadinessSummaryResult>;

// Matches getReadinessSummaryBatchInput's server-side limit.
const READINESS_BATCH_LIMIT = 100;

export async function fetchStrategyReadinessSummaries(
    strategyIds: readonly number[],
    fetchBatch: FetchReadinessBatch
): Promise<ReadinessSummaryResult> {
    const summaries: ReadinessSummaryResult['summaries'] = [];

    for (let offset = 0; offset < strategyIds.length; offset += READINESS_BATCH_LIMIT) {
        const response = await fetchBatch({
            strategyIds: strategyIds.slice(offset, offset + READINESS_BATCH_LIMIT)
        });
        summaries.push(...response.summaries);
    }

    return { summaries };
}
